import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface IDomainItem {
  readonly _id: string;
  readonly title: string;
  readonly siteName?: string;
}

export interface IDomainSelector {
  readonly id: string;
  readonly type: MESSAGES.DOMAIN_SELECTOR;
  readonly items: IDomainItem[];
  readonly nodeId: string;
  readonly pageSize: number;
  readonly rm: boolean;
  readonly role?: string;
}

export const createDomainSelector = (data): IDomainSelector => ({
  id: data.id || uuid(),
  type: MESSAGES.DOMAIN_SELECTOR,
  items: data.items,
  nodeId: data.nodeId,
  pageSize: data.pageSize,
  rm: Boolean(data.rm),
});
